import type { MasterScheduleGranularity } from '@interfaces/IMasterSchedule';

/* Pure tick helper for the Master Schedule card's day/week/month axis.
   Granularity is a runtime UI choice, so it lives on the component side and
   the derivation stays stable across zoom toggles. */

const DAY_MS = 86_400_000;

/** Tick anchor timestamps (UTC ms) for the axis at the chosen granularity.
 *  month → reuse model.monthStartsMs; week → UTC week-starts within the window;
 *  day → every calendar day. Each anchor maps to a label + a gridline. */
export function tickAnchorsMs(
  windowStartMs: number,
  windowEndMs: number,
  monthStartsMs: number[],
  granularity: MasterScheduleGranularity,
): number[] {
  if (granularity === 'month') return monthStartsMs;
  if (granularity === 'day') {
    const out: number[] = [];
    for (let t = windowStartMs; t < windowEndMs; t += DAY_MS) out.push(t);
    return out;
  }
  // week: align to the UTC week-start (Sunday) at/before windowStart, step +7d.
  const dow = new Date(windowStartMs).getUTCDay();
  const out: number[] = [];
  for (let t = windowStartMs - dow * DAY_MS; t < windowEndMs; t += 7 * DAY_MS) {
    if (t >= windowStartMs) out.push(t);
  }
  return out;
}
